export const availableBackgroundImages = [
    {
        original: 'http://lorempixel.com/1000/600/nature/1/',
        thumbnail: 'http://lorempixel.com/250/150/nature/1/'
    },
    {
        original: 'http://lorempixel.com/1000/600/nature/2/',
        thumbnail: 'http://lorempixel.com/250/150/nature/2/'
    },
    {
        original: 'http://lorempixel.com/1000/600/nature/3/',
        thumbnail: 'http://lorempixel.com/250/150/nature/3/'
    },
    {
        original: 'http://lorempixel.com/1000/600/nature/4/',
        thumbnail: 'http://lorempixel.com/250/150/nature/4/'
    },
    {
        original: 'http://lorempixel.com/1000/600/nature/5/',
        thumbnail: 'http://lorempixel.com/250/150/nature/5/'
    },
    {
        original: 'http://lorempixel.com/1000/600/nature/6/',
        thumbnail: 'http://lorempixel.com/250/150/nature/6/'
    },
    {
        original: 'http://lorempixel.com/1000/600/nature/7/',
        thumbnail: 'http://lorempixel.com/250/150/nature/7/'
    },
    {
        original: 'http://lorempixel.com/1000/600/nature/8/',
        thumbnail: 'http://lorempixel.com/250/150/nature/8/'
    }
];

export const availableLogoImages = [
    {
        original: 'http://lorempixel.com/1000/600/business/1/',
        thumbnail: 'http://lorempixel.com/250/150/business/1/'
    },
    {
        original: 'http://lorempixel.com/1000/600/business/2/',
        thumbnail: 'http://lorempixel.com/250/150/business/2/'
    },
    {
        original: 'http://lorempixel.com/1000/600/business/3/',
        thumbnail: 'http://lorempixel.com/250/150/business/3/'
    },
    {
        original: 'http://lorempixel.com/1000/600/business/4/',
        thumbnail: 'http://lorempixel.com/250/150/business/4/'
    },
    {
        original: 'http://lorempixel.com/1000/600/business/5/',
        thumbnail: 'http://lorempixel.com/250/150/business/5/'
    },
    {
        original: 'http://lorempixel.com/1000/600/business/6/',
        thumbnail: 'http://lorempixel.com/250/150/business/6/'
    },
    {
        original: 'http://lorempixel.com/1000/600/business/7/',
        thumbnail: 'http://lorempixel.com/250/150/business/7/'
    },
    {
        original: 'http://lorempixel.com/1000/600/business/8/',
        thumbnail: 'http://lorempixel.com/250/150/business/8/'
    }
];



// WEBPACK FOOTER //
// ./src/constants/availableImages.js